import React from 'react';
import { useFilter } from '../FilterContext';
import '../CSS/Global.css';

const FilterDrawer = () => {
  const {
    showDrawer,
    setShowDrawer,
    entriesPerPage,
    setEntriesPerPage,
    sortOrder,
    setSortOrder,
    customDate,
    setCustomDate,
  } = useFilter();

  const handleReset = () => {
    setEntriesPerPage(10);
    setSortOrder('desc');
    setCustomDate({ from: '', to: '' });
  };

  if (!showDrawer) return null;

  return (
    <div className="premium-filter-drawer">
      <div className="premium-drawer-header">
        <h2>⚙️ Advanced Filters</h2>
        <button className="premium-close-btn" onClick={() => setShowDrawer(false)}>×</button>
      </div>

      <div className="premium-drawer-body">
        <div className="premium-filter-group">
          <label>Entries per page</label>
          <select value={entriesPerPage} onChange={(e) => setEntriesPerPage(Number(e.target.value))}>
            {[10, 20, 50, 100, 500].map(n => (
              <option key={n} value={n}>{n}</option>
            ))}
          </select>
        </div>

        <div className="premium-filter-group">
          <label>Sort by</label>
          <select value={sortOrder} onChange={(e) => setSortOrder(e.target.value)}>
            <option value="desc">Newest First</option>
            <option value="asc">Oldest First</option>
          </select>
        </div>

        <div className="premium-filter-group">
          <label>Date Range</label>
          <div className="premium-date-range">
            <input
              type="date"
              value={customDate.from}
              onChange={(e) => setCustomDate({ ...customDate, from: e.target.value })}
            />
            <input
              type="date"
              value={customDate.to}
              onChange={(e) => setCustomDate({ ...customDate, to: e.target.value })}
            />
          </div>
        </div>
      </div>

      <div className="premium-drawer-footer">
        <button className="premium-reset-btn" onClick={handleReset}>Reset</button>
        <button className="premium-apply-btn" onClick={() => setShowDrawer(false)}>Apply</button>
      </div>
    </div>
  );
};

export default FilterDrawer;
